import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Shuffle from 'shufflejs'
import NewsCard from './Card'

export default class News extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.row = React.createRef()
  }

  render () {
    if (!this.state.news) return
    return (
      <>
        <hr />
        <div className='float-end text-end'>
          <sup>
            Last Updated: {this.state.news.lastUpdated}
            <br />
            Provided by <a href='https://www.kentlive.news/' target='_blank' rel="noreferrer">KentLive</a>
          </sup>
        </div>
        <h1 className='mb-4'>Local News</h1>
        <Row ref={this.row} className='row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4'>
          {this.state.news.feed.map((story, i) => {
            return (
              <Col key={i}>
                <NewsCard story={story} />
              </Col>
            )
          })}
        </Row>
      </>
    )
  }

  componentDidMount () {
    this.socket = window.io('/news', { transports: ['websocket'] })
    this.socket.on('update', news => this.setState({ news }))
  }

  componentDidUpdate () {
    if (!this.state.news) return
    if (!this.shuffle) {
      this.shuffle = new Shuffle(this.row.current, {
        itemSelector: '.col'
      })
    }
    setTimeout(() => {
      this.shuffle.update()
    }, 300)
  }
}
